import Axios from 'axios'
const AUTH_API_HOST = process.env.VUE_APP_AUTH_API_HOST
const AUTH_ACCESS_TOKEN_KEY = process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY
const AuthService = {
  /**
   * @description auth login
   *
   * @returns {object}
   */
  login(data) {
    const apiURL = `${AUTH_API_HOST}/api/login`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      withCredentials: true,
      headers: {},
      data
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  },
  /**
   * @description auth logout
   *
   * @returns {object}
   */
  logout() {
    const apiURL = `${AUTH_API_HOST}/api/logout`
    const token = window.localStorage.getItem(AUTH_ACCESS_TOKEN_KEY)
    return Axios.request({
      method: 'POST',
      url: apiURL,
      withCredentials: true,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  },
  /**
   * @description auth register
   *
   * @returns {object}
   */
  register(data) {
    const apiURL = `${AUTH_API_HOST}/api/register`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {},
      data
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  },
  /**
   * @description auth register
   *
   * @returns {object}
   */
  provider(data) {
    const apiURL = `${AUTH_API_HOST}/api/provider`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      withCredentials: true,
      headers: {},
      data
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  },
  /**
   * @description request password reset email
   *
   * @returns {object}
   */
  requestResetEmail(email) {
    const apiURL = `${AUTH_API_HOST}/api/password/email`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {
        'Content-type': 'application/json'
      },
      data: {
        email
      }
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  },
  /**
   * @description password reset with token
   *
   * @returns {object}
   */
  resetEmail(password, email, token) {
    const apiURL = `${AUTH_API_HOST}/api/password/reset`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {},
      data: {
        password,
        email,
        token
      }
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  },
  /**
   * @description request a twitter oauth token
   *
   * @returns {object}
   */
  twitterequestToken(params) {
    const apiURL = `${AUTH_API_HOST}/api/twitter/request_token`
    return Axios.request({
      method: 'GET',
      url: apiURL,
      headers: {},
      params
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  },
  /**
   * @description sign in twitter with oauth token
   *
   * @returns {object}
   */
  twitterAccessToken(params) {
    const apiURL = `${AUTH_API_HOST}/api/twitter/access_token`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {},
      params: {},
      data: params
    })
      .then(res => {
        if (res) {
          return res
        }
        return null
      })
      .catch(error => {
        if (error.response) {
          return error.response
        }
        return null
      })
  }
}
export default AuthService
